/**
 * Created by abbeymart on 2016-12-26.
 */
import type { RouteRecordRaw } from "vue-router";

export const getStartRoutes: Array<RouteRecordRaw> = [
    {
        path     : '/getStart',
        name     : 'getStart',
        component: () => import("pages/central/common/GettingStarted.vue"),
        meta     : {
            title: "Getting Started Guides",
        },
    },
];
